import { Skeleton } from "@bednbody/ui/components/skeleton";
import { Bar, BarChart, BarXAxis, ChartTooltip, Grid } from "@/components/charts";
import type { DailyBookingStat } from "../ops-dashboard.hooks";

/**
 * Bklit (@visx) grouped bar chart of the last 7 days: total bookings vs
 * completed. Complements the recharts TrendsCard/MiniAnalytics — same weekly
 * feed, at-a-glance shape. Colors use the brand chart tokens.
 */
export function WeeklyBookingsChart({
  weekly,
  isLoading = false,
}: {
  weekly: DailyBookingStat[];
  isLoading?: boolean;
}) {
  if (isLoading) {
    return <Skeleton className="h-56 motion-reduce:animate-none" />;
  }
  if (weekly.length === 0 || weekly.every((d) => d.bookings === 0)) {
    return (
      <div className="flex h-56 items-center justify-center text-sm text-muted-foreground">
        No bookings in the last 7 days.
      </div>
    );
  }

  // Plain objects (Bklit's data prop is Record<string, unknown>[]; the
  // DailyBookingStat interface has no index signature).
  const chartData = weekly.map((d) => ({
    day: d.day,
    bookings: d.bookings,
    completed: d.completed,
  }));

  return (
    <div className="pt-1">
      <BarChart data={chartData} xDataKey="day" aspectRatio="5 / 2" barGap={0.25}>
        <Grid horizontal />
        <Bar dataKey="bookings" fill="var(--chart-line-primary)" />
        <Bar dataKey="completed" fill="var(--chart-line-secondary)" />
        <BarXAxis />
        <ChartTooltip />
      </BarChart>
      <div className="mt-3 flex items-center justify-center gap-5 text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5">
          <span className="size-2.5 rounded-sm" style={{ background: "var(--chart-1)" }} />
          Bookings
        </span>
        <span className="flex items-center gap-1.5">
          <span className="size-2.5 rounded-sm" style={{ background: "var(--chart-2)" }} />
          Completed
        </span>
      </div>
    </div>
  );
}
